<label class="media-entry">
  <i
    class="placeholder-icon nc-icon nc-big-add-thick"
    [class.blue-color]="isMessagePhoto"
    [class.gold-color]="isSecret"
    [class.green-color]="!isMessagePhoto && !isSecret"
  ></i>

  <div class="labels t-11@r">
    @if (isSecret) {
      <sb-icon class="cloud-color" [name]="'lock'" [size]="'4'" />
    }
    @if (isVideo) {
      <sb-icon class="cloud-color" [name]="'video-on'" [size]="'4'" />
    }
  </div>
</label>
